import React from "react";
import { useSelector } from "react-redux";
import { Language } from "../../../redux/store/base/language";

import Doctor from "./../../../assets/images/Icons/Doctor.svg";
import Hospital from "./../../../assets/images/Icons/Hospital.svg";
import Therapists from "./../../../assets/images/Icons/Therapists.svg";
import Dieticians from "./../../../assets/images/Icons/Dieticians.svg";
import Polyclinic from "./../../../assets/images/Icons/Polyclinic.svg";

//Style
import { MDBRow, MDBCol, MDBCard, MDBCardBody } from "mdbreact";
import "./Service.scss";
import { navigate } from "gatsby";

const Navgate = (path: string) => navigate(`/${path}`);

const Service = (props: {}) => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );

  return (
    <MDBRow className="service mx-auto mb-5">
      <MDBCol
        lg={"4"}
        md={"6"}
        sm={"6"}
        xs={"12"}
        className="pointer"
        onClick={() => Navgate("doctor")}
      >
        <MDBCard>
          <MDBCardBody>
            <img src={Doctor} alt="" />
            <h5>{state?.doctors}</h5>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol
        lg={"4"}
        md={"6"}
        sm={"6"}
        xs={"12"}
        className="pointer"
        onClick={() => Navgate("hospital")}
      >
        <MDBCard>
          <MDBCardBody>
            <img src={Hospital} alt="" />
            <h5>{state?.hospitals}</h5>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol lg={"4"} md={"6"} sm={"6"} xs={"12"}>
        <MDBCard>
          <MDBCardBody>
            <img src={Dieticians} alt="" />
            <h5>{state?.dieticians}</h5>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol lg={"4"} md={"6"} sm={"6"} xs={"12"}>
        <MDBCard>
          <MDBCardBody>
            <img src={Polyclinic} alt="" />
            <h5>{state?.polyclinic}</h5>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol lg={"4"} md={"6"} sm={"6"} xs={"12"}>
        <MDBCard>
          <MDBCardBody>
            <img src={Therapists} alt="" />
            <h5>{state?.therapists}</h5>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol lg={"4"} md={"6"} sm={"6"} xs={"12"}>
        <MDBCard>
          <MDBCardBody>
            <span>
              <a>{state?.allServices}</a>
            </span>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    </MDBRow>
  );
};

export default Service;
